// Copyright 2020 Prescryptive Health, Inc.

import { ReactElement } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { unauthenticatedRouteConfig } from '../../unauthenticated-route-config';
import { Main } from './pre-auth.stack-navigator.styled-components';
import { DrugSearchScreen } from '../../../components/screens/drug-search/drug-search.screen';
import { DrugSearchConfigContextProvider } from '../../../providers/drug-search-config/drug-search-config.context-provider';

export const PreAuthStackNavigator = (): ReactElement => {
  return (
    <Main>
      <Routes>
        <Route
          path={unauthenticatedRouteConfig.drugSearch.route}
          element={
            <DrugSearchConfigContextProvider>
              <DrugSearchScreen />
            </DrugSearchConfigContextProvider>
          }
        />
        <Route path='*' element={<Navigate to={unauthenticatedRouteConfig.drugSearch.route} replace />} />
      </Routes>
    </Main>
  );
};
